"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorGenerator = void 0;
const api = require("./apis");
const errorGenerator = (msg) => (error) => ({
    type: 'CRASH',
    code: 500,
    error,
    message: msg || error.message,
});
exports.errorGenerator = errorGenerator;
//# sourceMappingURL=api.js.map